"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = require("../../../../Framework/ComponentContainer");
var _configuration = require("../../../configuration");
var _Selectors = require("../../../Reducers/Configurator/Selectors");
var _FallbackVisualization = require("../Components/FallbackVisualization/FallbackVisualization");
var _Progress = _interopRequireDefault(require("../../../Shared/Components/Progress/Progress"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(state) {
  var variantIdentifier = (0, _Selectors.getSelectedVariantIdentifier)((0, _Selectors.getConfigurator)(state));
  var imageSrc = variantIdentifier ? "".concat((0, _configuration.getConf)('network.host'), "/images/item/image/").concat(variantIdentifier, ".jpg") : '';
  return {
    Component: _FallbackVisualization.FallbackVisualization,
    ProgressComponent: _Progress["default"],
    imageSrc: imageSrc
  };
};
var _default = exports["default"] = (0, _ComponentContainer.containerConnect)(mapStateToProps);